import React, { FunctionComponent, useCallback } from 'react';
import { Presentation } from './presentation';
import { EducationalHistories, CareerHistories, CareerEmploymentType } from '../../../types/personShow';

type Props = {
  mainTitle: string;
  isOneYearPassed: boolean;
  penIconImg: string;
  introduction: string;
  educationalHistories: EducationalHistories[];
  careerHistories: CareerHistories[];
  activity: string;
  slogan: string;
  interests: string[];
  skills: string[];
  favoriteBrands: string[];
  handleOpenModal: (target: string, title: string) => void;
  onChangeClickTarget: (value: number) => void;
  isShow: boolean;
  isStudent: boolean;
  careerEmploymentTypes: CareerEmploymentType[];
};

export const Component: FunctionComponent<Props> = ({
  mainTitle,
  isOneYearPassed,
  penIconImg,
  introduction,
  educationalHistories,
  careerHistories,
  activity,
  slogan,
  interests,
  skills,
  favoriteBrands,
  handleOpenModal,
  onChangeClickTarget,
  isShow,
  isStudent,
  careerEmploymentTypes,
}) => {
  const handleClick = useCallback(
    (target: string, title: string) => {
      handleOpenModal(target, title);
    },
    [handleOpenModal]
  );

  const handleChangeClickTarget = useCallback(
    (value: number) => {
      onChangeClickTarget(value);
    },
    [onChangeClickTarget]
  );  

  return (
    <Presentation
      penIconImg={penIconImg}
      mainTitle={mainTitle}
      isOneYearPassed={isOneYearPassed}
      introduction={introduction}
      educationalHistories={educationalHistories}
      careerHistories={careerHistories}
      activity={activity}
      slogan={slogan}
      interests={interests}
      skills={skills}
      favoriteBrands={favoriteBrands}
      handleClick={handleClick}
      onChangeClickTarget={handleChangeClickTarget}
      isShow={isShow}
      isStudent={isStudent}
      careerEmploymentTypes={careerEmploymentTypes}
    />
  );
};
